import { NgModule } from '@angular/core';

import { NumberValidator }     from './number.validator';
import { PhoneValidator }      from './phone.validator';
import { PostcodeValidator }   from './postcode.validator';
import { TimeValidator }       from './time.validator';
import { UniquenessValidator } from './uniqueness.validator';

@NgModule({
  declarations: [
    NumberValidator,
    PhoneValidator,
    PostcodeValidator,
    TimeValidator,
    UniquenessValidator
  ],
  exports: [
    NumberValidator,
    PhoneValidator,
    PostcodeValidator,
    TimeValidator,
    UniquenessValidator
  ]
})
export class ValidatorsModule {}
